/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvitationChannelFromJSON, InvitationChannelToJSON, } from './InvitationChannel';
/**
 * Check if a given object implements the InvitationCreated interface.
 */
export function instanceOfInvitationCreated(value) {
    if (!('token' in value) || value['token'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('channel' in value) || value['channel'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    return true;
}
export function InvitationCreatedFromJSON(json) {
    return InvitationCreatedFromJSONTyped(json, false);
}
export function InvitationCreatedFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'token': json['token'],
        'url': json['url'],
        'channel': InvitationChannelFromJSON(json['channel']),
        'expiresIn': json['expires_in'],
    };
}
export function InvitationCreatedToJSON(json) {
    return InvitationCreatedToJSONTyped(json, false);
}
export function InvitationCreatedToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'token': value['token'],
        'url': value['url'],
        'channel': InvitationChannelToJSON(value['channel']),
        'expires_in': value['expiresIn'],
    };
}
